var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "availability-svgrepo-com-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m117.8 177.1c-14.2 0-25.6-11.4-25.6-25.6 0-14.2 11.4-25.6 25.6-25.6 14.1 0 25.5 11.4 25.5 25.6 0 14.2-11.4 25.6-25.5 25.6zm15.5-25.6c0-8.6-6.9-15.6-15.5-15.6-8.7 0-15.6 7-15.6 15.6 0 8.6 6.9 15.6 15.6 15.6 8.6 0 15.5-7 15.5-15.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m280.5 151.9c0 12-9.8 21.8-21.9 21.8h-71.3c-12 0-21.8-9.8-21.8-21.8 0-12 9.8-21.8 21.8-21.8h71.3c12.1 0 21.9 9.8 21.9 21.8zm-10 0c0-6.6-5.4-11.9-11.9-11.9h-71.3c-6.5 0-11.8 5.3-11.8 11.9 0 6.5 5.3 11.8 11.8 11.8h71.3c6.5 0 11.9-5.3 11.9-11.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m49.7 129.1c0-19.4 15.7-35 35-35h342.9c19.3 0 35 15.6 35 35v250c0 19.3-15.7 35-35 35h-342.9c-19.3 0-35-15.7-35-35zm392.9 249.9v-179.9h-372.9v180c0 8.2 6.7 15 15 15h342.9c8.3 0 15-6.8 15-15zm0.1-250c0-8.3-6.8-15-15-15h-342.9c-8.2 0-15 6.7-15 15v60h372.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m229.9 312.3l-57.1-22.6 57.1-21.9v-23.3l-81.8 35.5v19.7l81.9 35.7zm54.4-84.9h-17.2l-29.6 123.6h16.9zm89.5 52.7l-82-35.5 0.1 22.9 57.1 22.3-57.1 22.5v23.1l82-35.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.559420b278674fd6d78984156653d76f.svg";
export { ForwardRef as ReactComponent };